'use client';

import { FC, ReactNode } from 'react';
import { COLORS } from '@/constants';
import styled, { css } from 'styled-components';

export type WlasCalloutVariant = 'info' | 'warn' | 'tip';

interface WlasCalloutProps {
  variant: WlasCalloutVariant;
  children: ReactNode;
}

const variantStyles = {
  info: css`
    background: #eff6ff;
    border-left-color: #3b82f6;
  `,
  warn: css`
    background: #fffbeb;
    border-left-color: #f59e0b;
  `,
  tip: css`
    background: #f0fdf4;
    border-left-color: #22c55e;
  `,
};

const ICONS: Record<WlasCalloutVariant, string> = {
  info: 'ℹ️',
  warn: '⚠️',
  tip: '✅',
};

const CalloutRoot = styled.div<{ $variant: WlasCalloutVariant }>`
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 6px;
  border-left: 3px solid transparent;
  font-size: 14px;
  line-height: 1.55;
  color: ${COLORS['primary/900']};
  ${({ $variant }) => variantStyles[$variant]}
`;

const CalloutIcon = styled.span`
  flex-shrink: 0;
  font-size: 15px;
  margin-top: 1px;
`;

const CalloutBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const WlasCallout: FC<WlasCalloutProps> = ({ variant, children }) => (
  <CalloutRoot $variant={variant}>
    <CalloutIcon>{ICONS[variant]}</CalloutIcon>
    <CalloutBody>{children}</CalloutBody>
  </CalloutRoot>
);
